import { FormattedMessage, useIntl } from 'react-intl';

import iwocaMessages from './ApplicantCallAction.messages';
import iwocaPayMessages from './ApplicantCallModal.iwocapay.messages';
import styles from './ApplicantCallAction.module.css';
import { PhoneNumberButton } from '../../../ui/supportWidget/supportActionList/callSupportButtonWithModal/callSupportModal/phoneNumberButton';

const ApplicantCallModal = ({
    isIwocaPay
}: {
    onClose: () => void;
    isIwocaPay: boolean;
}) => {
    const intl = useIntl();

    const messages = isIwocaPay ? iwocaPayMessages : iwocaMessages;
    return (
        <div className={styles.ApplicantCallModal}>
            <h2 className={styles.title}>
                <FormattedMessage {...messages.modalTitle} />
            </h2>
            <div className={styles.callSubText}>
                <FormattedMessage {...messages.callSubText} />
            </div>
            <div className={styles.number}>
                <PhoneNumberButton
                    displayPhoneNumber={
                        <FormattedMessage {...messages.displayPhoneNumber} />
                    }
                    callPhoneNumber={intl.formatMessage(
                        messages.callPhoneNumber
                    )}
                />
            </div>

            <div
                className={styles.availability}
                data-testid="availability-info"
            >
                <div className={styles.availabilityMonFri}>
                    <FormattedMessage
                        tagName="strong"
                        {...messages.availabilityMessageLineOne}
                    />
                    <div className={styles.openingTimes}>
                        <FormattedMessage
                            {...messages.timesForMessageLineOne}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default ApplicantCallModal;
